require('./brokerAlertsConfigView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');

// @actions
const {
    createAlert,
    selectProduct,
    selectRateType,
    selectRateTypeForIndex,
    selectRateValueForIndex,
    changeConfigurationType,
    selectRateValue,
    cancelAlert,
    deleteCustomAlert,
    editCustomAlert,
    requestCustomAlerts,
    getDefaultAlerts,
    handleSubmit,
    handleIndexSubmit,
    updateIndexAlert,
    updateCustomAlert,
    disableProductError,
    disableRateTypeError,
    disableRateValueError,
    requestConditions,
    reset,
    resetSelectedValuesForIndex,
    resetSelectedValuesStocks
} = require('actions/brokerAlertsConfig');
const brokerTodaysMainStocksActions = require('actions/brokerTodaysMainStocks');

const BrokerSearchAction = require('actions/brokerSearch');

// @utils
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');

// @components
const BrokerAlertsCreate = require('components/broker/brokerAlertsConfig/brokerAlertsConfigCreate/brokerAlertsConfigCreate');
const BrokerAlertsConfigCustom = require('components/broker/brokerAlertsConfig/brokerAlertsConfigCustom/brokerAlertsConfigCustom');
const BrokerAlertsConfigDefault = require('components/broker/brokerAlertsConfig/brokerAlertsConfigDefault/brokerAlertsConfigDefault');
const BrokerAlertsConfigPhone = require('components/broker/brokerAlertsConfig/brokerAlertsConfigPhone/brokerAlertsConfigPhone');
const AppDownloadWidget = require('components/appDownloadWidget/appDownloadWidget');

// @constants
const { BROKER_ALERT_CONFIGURATION_TYPE_STOCKS_OPTION } = require('constants/index');

class BrokerAlertsConfigView extends React.Component {

    constructor(props) {
        super(props);
        this.createAlert = this.createAlert.bind(this);
        this.createButton = this.createButton.bind(this);
        this.handleConfigurationTypeChange = this.handleConfigurationTypeChange.bind(this);
        this.handleProductSelection = this.handleProductSelection.bind(this);
        this.handleRateTypeSelection = this.handleRateTypeSelection.bind(this);
        this.handleInputRateChanged = this.handleInputRateChanged.bind(this);
        this.handleEditCustomAlert = this.handleEditCustomAlert.bind(this);
        this.handleDeleteCustomAlert = this.handleDeleteCustomAlert.bind(this);
        this.handleUpdateCustomAlert = this.handleUpdateCustomAlert.bind(this);
    }

    componentDidMount() {
        this.props.requestCustomAlerts();
        this.props.getDefaultAlerts();
        this.props.requestConditions();
        this.props.getIndexes();
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.immAlertsConfig.get('customAlertsAreOutdated') && nextProps.immAlertsConfig.get('customAlertsAreOutdated')) {
            this.props.requestCustomAlerts();
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    createAlert(item) {
        const {
            immAlertsConfig,
            immBrokerExchangeIndexes,
            searchState,
            handleSearchProduct,
            handleSearchReset,
            handleUpdateIndexAlert,
            handleIndexSubmit,
            handleSubmit,
            cancelAlert,
            updateCustomAlert,
            immAlertsConditions,
            requestConditions
        } = this.props;

        const editIsActive = immAlertsConfig.get('editIsActive');
        const boxTitle = editIsActive ? '' : formatText('broker-alertsConfigCreateTitle');

        return (
            <div id="printable-wizard">
                <ContentBox
                    title={boxTitle}
                    customClassName="broker-alerts-config-view__alerts-create-box"
                >
                    <BrokerAlertsCreate
                        immAlertsConditions={immAlertsConditions}
                        searchState={searchState}
                        immAlertsConfig={immAlertsConfig}
                        onHandleConfigurationTypeChange={this.handleConfigurationTypeChange}
                        onHandleUpdateIndexAlert={handleUpdateIndexAlert}
                        onHandleSearch={handleSearchProduct}
                        onHandleSearchReset={handleSearchReset}
                        onHandleSelection={this.handleProductSelection}
                        onHandleRateSelection={this.handleRateTypeSelection}
                        onHandleInputRate={this.handleInputRateChanged}
                        onHandleCancelNewAlert={cancelAlert}
                        onHandleSubmitAlert={handleSubmit}
                        onhandleIndexSubmit={handleIndexSubmit}
                        onHandleEditAlert={updateCustomAlert}
                        editSearchResult={item}
                        retryRequestAlertsConditions={requestConditions}
                        immBrokerExchangeIndexes={immBrokerExchangeIndexes}
                    />
                </ContentBox>
            </div>
        );
    }

    createButton() {
        return (
            <OKButton
                id="btnCreateNewAlertText"
                modifier="primary"
                onClick={this.props.handleCreateAlert}
            >
                {formatText('broker-alertsConfigCreateNewAlert')}
            </OKButton>
        );
    }

    handleConfigurationTypeChange(option) {
        const { handleConfigurationTypeChange, immBrokerExchangeIndexes, immAlertsConfig, resetSelectedValuesForIndex, resetSelectedValuesStocks } = this.props;
        const indexName = immBrokerExchangeIndexes.get('defaultIndex') && (immBrokerExchangeIndexes.get('defaultIndex')).replace(/ +/g, "");
        if (!immAlertsConfig.getIn(['selectedValues', 'stocks', 'rateValue'])) {
            resetSelectedValuesStocks();
        }

        if (!immAlertsConfig.getIn(['selectedValues', indexName, 'rateValue'])) {
            resetSelectedValuesForIndex(indexName); 
        }
        handleConfigurationTypeChange(option.value, indexName);
    }

    handleDeleteCustomAlert(alert) {
        this.props.deleteCustomAlert(alert);
    }

    handleEditCustomAlert(alert) {
        this.props.editCustomAlert(alert);
    }

    handleInputRateChanged(rate) {
        const { immAlertsConfig, immBrokerExchangeIndexes, disableRateValueError, handleSelectRateValue, handleSelectRateValueForIndex } = this.props;
        const indexName = immBrokerExchangeIndexes.get('defaultIndex') && (immBrokerExchangeIndexes.get('defaultIndex')).replace(/ +/g, "");
        const configurationType = immAlertsConfig.getIn(['selectedValues', 'configurationType']);
        const rateValueError = immAlertsConfig.getIn(['selectedValues', 'stocks', 'errorFlags', 'rateValueInput']);

        if (rateValueError) {
            disableRateValueError();
        }

        if (configurationType === BROKER_ALERT_CONFIGURATION_TYPE_STOCKS_OPTION) {
            handleSelectRateValue(rate);
        } else {
            handleSelectRateValueForIndex(rate, indexName);
        }
    }

    handleProductSelection(option) {
        const { immAlertsConfig, disableProductError, handleSelectProduct } = this.props;
        const productInputError = immAlertsConfig.getIn(['selectedValues', 'stocks', 'errorFlags', 'productInput']);

        if (productInputError) {
            disableProductError();
        }

        handleSelectProduct(option);
    }

    handleRateTypeSelection(option) {
        const {
            immAlertsConfig,
            disableRateTypeError,
            disableRateValueError,
            handleSelectRateType,
            handleSelectRateTypeForIndex,
            handleSelectRateValue,
            immBrokerExchangeIndexes
        } = this.props;
        const configurationType = immAlertsConfig.getIn(['selectedValues', 'configurationType']);
        const rateTypeError = immAlertsConfig.getIn(['selectedValues', 'stocks', 'errorFlags', 'rateTypeInput']);
        const rateValueError = immAlertsConfig.getIn(['selectedValues', 'stocks', 'errorFlags', 'rateValueInput']);
        const defaultIndexName = immBrokerExchangeIndexes.get('defaultIndex') && (immBrokerExchangeIndexes.get('defaultIndex')).replace(/ +/g, "");

        if (rateTypeError) {
            disableRateTypeError();
        } else if (rateValueError) {
            disableRateValueError();
        }

        if (configurationType === BROKER_ALERT_CONFIGURATION_TYPE_STOCKS_OPTION) {
            handleSelectRateType(option);
            handleSelectRateValue('');
        } else {
            handleSelectRateTypeForIndex(option, defaultIndexName);
        }
    }

    handleUpdateCustomAlert(alert) {
        this.props.updateCustomAlert(alert);
    }

    render() {
        const { immAlertsConfig, requestCustomAlerts, handleCreateAlert } = this.props;
        const defaultAlerts = immAlertsConfig.get('defaultAlerts');
        const immCustomAlerts = immAlertsConfig.get('customAlerts');
        const createIsExpanded = immAlertsConfig.get('createIsActive');
        const editIsActive = immAlertsConfig.get('editIsActive');

        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('breadcrumb-brokerAlertsConfig'),
                url: ''
            }
        ];

        const alertsBoxTitle = <OKBoxTitle value={formatText('broker-alertsConfigInvestmentAlerts')} />;

        let createButton;
        let createBox;

        if (createIsExpanded) {
            createBox = this.createAlert();
        } else {
            createButton = this.createButton();
        }

        return (
            <div id="alertsConfig" className="broker-alerts-config-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={mappingBreadcrumb}
                        finalTitle={getFinalTitle('broker-alertsConfigTitle')}
                    >
                        {createButton}

                    </OKHeaderSubPage>
                </OKCover>
                <section id="alertsConfigSection" className="broker-alerts-config-view__body">
                    <div className="row no-outside-gutter">
                        <div className="col-xs-8">

                            {createBox}

                            <ContentBox title={alertsBoxTitle}>
                                <BrokerAlertsConfigDefault
                                    alerts={defaultAlerts}
                                    hideAlterts={true}
                                />
                                <BrokerAlertsConfigCustom
                                    isFetching={immAlertsConfig.get('isGettingAlerts')}
                                    fetchErrorReceived={immAlertsConfig.get('getAlertsErrorReceived')}
                                    fetchSuccess={immAlertsConfig.get('getAlertsFetchSuccess')}
                                    immAlerts={immCustomAlerts}
                                    onDeleteAlert={this.handleDeleteCustomAlert}
                                    onEditAlert={this.handleEditCustomAlert}
                                    editIsActive={editIsActive}
                                    createIsExpanded={createIsExpanded}
                                    createAlertBox={this.createAlert}
                                    createAlertBoxAction={handleCreateAlert}
                                    requestDefaultAlerts={requestCustomAlerts}
                                />
                            </ContentBox>
                        </div>
                        <div className="col-xs-4">
                            <ContentBox>
                                <BrokerAlertsConfigPhone immProfileFields={this.props.immProfileFields} />
                            </ContentBox>
                            <AppDownloadWidget />
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

BrokerAlertsConfigView.propTypes = {
    getIndexes: PropTypes.func,
    immBrokerExchangeIndexes: PropTypes.object,
    immProfileFields: PropTypes.object,
    immAlertsConditions: PropTypes.object.isRequired,
    requestProfile: PropTypes.func,
    immAlertsConfig: PropTypes.object.isRequired,
    handleCreateAlert: PropTypes.func.isRequired,
    searchState: PropTypes.object.isRequired,
    handleConfigurationTypeChange: PropTypes.func.isRequired,
    handleIndexSubmit: PropTypes.func.isRequired,
    handleSearchProduct: PropTypes.func.isRequired,
    handleSearchReset: PropTypes.func.isRequired,
    handleSelectProduct: PropTypes.func.isRequired,
    handleSelectRateType: PropTypes.func.isRequired,
    handleSelectRateTypeForIndex: PropTypes.func.isRequired,
    handleSelectRateValue: PropTypes.func.isRequired,
    handleSelectRateValueForIndex: PropTypes.func.isRequired,
    handleUpdateIndexAlert: PropTypes.func.isRequired,
    cancelAlert: PropTypes.func.isRequired,
    deleteCustomAlert: PropTypes.func.isRequired,
    editCustomAlert: PropTypes.func.isRequired,
    getDefaultAlerts: PropTypes.func.isRequired,
    requestCustomAlerts: PropTypes.func.isRequired,
    updateCustomAlert: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    disableProductError: PropTypes.func.isRequired,
    disableRateTypeError: PropTypes.func.isRequired,
    disableRateValueError: PropTypes.func.isRequired,
    requestConditions: PropTypes.func.isRequired,
    reset: PropTypes.func,
    resetSelectedValuesForIndex: PropTypes.func.isRequired,
    resetSelectedValuesStocks: PropTypes.func.isRequired
};

module.exports.BrokerAlertsConfigView = connect(
    state => ({
        immBrokerExchangeIndexes: state.brokerExchangeIndexes,
        immProfileFields: state.profile,
        immAlertsConfig: state.brokerAlertsConfig,
        searchState: state.brokerSearch,
        immAlertsConditions: state.brokerAlertsConditions
    }), {
        getIndexes: brokerTodaysMainStocksActions.getIndexes,
        handleConfigurationTypeChange: changeConfigurationType,
        handleCreateAlert: createAlert,
        handleSelectProduct: selectProduct,
        handleSelectRateType: selectRateType,
        handleSelectRateTypeForIndex: selectRateTypeForIndex,
        handleSelectRateValue: selectRateValue,
        handleSelectRateValueForIndex: selectRateValueForIndex,
        handleSearchProduct: BrokerSearchAction.searchProduct,
        handleSearchReset: BrokerSearchAction.clearResults,
        handleUpdateIndexAlert: updateIndexAlert,
        cancelAlert,
        deleteCustomAlert,
        editCustomAlert,
        requestCustomAlerts,
        getDefaultAlerts,
        updateCustomAlert,
        handleIndexSubmit,
        handleSubmit,
        disableProductError,
        disableRateTypeError,
        disableRateValueError,
        requestConditions,
        reset,
        resetSelectedValuesForIndex,
        resetSelectedValuesStocks
    })(BrokerAlertsConfigView);
